import { render, staticRenderFns } from "./examineCar.vue?vue&type=template&id=157d4172&scoped=true&"
import script from "./examineCar.vue?vue&type=script&lang=js&"
export * from "./examineCar.vue?vue&type=script&lang=js&"
import style0 from "./examineCar.vue?vue&type=style&index=0&id=157d4172&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157d4172",
  null
  
)

export default component.exports